import React, { FC } from 'react'
import { connect } from 'react-redux'
import { setUIAction } from '../../../actions'
import { UI } from '../../../constants/ui'
import FooterMobile from '../../FooterMobile'
import Cargo from '../../../assets/CargoCombinedVertLogo.png'
import './welcome.less'
import { useTranslation } from 'react-i18next'


interface DispatchProps {
    setUI: (ui: UI) => void
}
const mapDispatchToProps = (dispatch: any): DispatchProps => ({
    setUI: (ui: UI): void => dispatch(setUIAction(ui)),
})

type Props = DispatchProps

const Welcome: FC<Props> = ({ setUI }) => {
    const { t } = useTranslation()

    const onClick = () => setUI(UI.MAIN)

    return (
        <div className="welcome-mobile">
            <div className="main">
                <div className="logo-container">
                    <img className="logo" src={Cargo} alt="cargo" />
                </div>
                <div className="info-container">
                    <div className="title" dangerouslySetInnerHTML={{ __html: t('welcomeTitleLine')}}></div>
                    <div className="lead-paragraph" dangerouslySetInnerHTML={{ __html: t('welcomeLeadParagraph')}} />
                    <div className="info" dangerouslySetInnerHTML={{ __html: t('welcomeText')}} />
                </div>
                <div className="button-container">
                    <button
                        className="main-button next"
                        onClick={onClick}
                    >{t('ok')}</button>
                </div>
            </div>
            <div className="welcome-footer">
                <FooterMobile />
            </div>
        </div>
    )
}

export default connect(null, mapDispatchToProps)(Welcome)